import PropTypes from 'prop-types';
import ProposalFormBody from './proposal-form-body';
import ProposalFormController from '../proposal-form-controller';
import { DynamicForm } from '@evertrue/sdk';
import { useProposalFormContext } from '../context/proposal-form-context';

const ProposalFormInner = ({
  proposal = {},
  primaryContactId,
  setProposal = () => null,
  closeModal = () => null,
  afterCreate = () => null,
}) => {
  const {
    rules,
    solicitorLimit,
    additionalContactLimit,
    designationLimit,
    standardFieldsConfig,
    hasCustomFields,
    customFields,
  } = useProposalFormContext();

  const editing = !!proposal.id;
  const initialValues = () => {
    if (editing) {
      return ProposalFormController.parseProposal(proposal);
    } else return ProposalFormController.defaultValues();
  };

  const handleSubmit = async (values) => {
    const newProposal = await ProposalFormController.submit(values, proposal?.id); // will update or create a proposal, depending on whether proposal.id exists
    setProposal(newProposal); // update the state with the new or updated proposal
    afterCreate(newProposal); // callback to perform any additional actions after creation or update
    closeModal(); // close the modal after submission
  };

  return (
    <DynamicForm
      type="proposal"
      rules={rules}
      additionalRules={ProposalFormController.getAdditionalRules(
        additionalContactLimit,
        solicitorLimit,
        designationLimit,
        standardFieldsConfig
      )}
      fieldsToValidate={ProposalFormController.standardFieldsWithCustomFields(hasCustomFields, customFields)}
      initialValues={initialValues()}
      handleSubmit={handleSubmit}
    >
      <ProposalFormBody
        editing={editing}
        proposal={proposal}
        primaryContactId={primaryContactId}
        setProposal={setProposal}
        closeModal={closeModal}
        afterCreate={afterCreate}
      />
    </DynamicForm>
  );
};

ProposalFormInner.propTypes = {
  proposal: PropTypes.object,
  primaryContactId: PropTypes.number,
  setProposal: PropTypes.func,
  closeModal: PropTypes.func,
  afterCreate: PropTypes.func,
};

export default ProposalFormInner;
